import config from '../config';
import { ApiError } from './ApiError';
import { getDefaultHeaders } from './helpers/api-helpers';
import { Tenant } from './model/tenant';

export async function getMissingCultures(tenant: Tenant, folder: string): Promise<string[]> {
  const endpoint = `/api/v2/accounts/${tenant.accountId}/content-area/${
    tenant.areaId
  }/Translations/${encodeURIComponent(folder)}/missing-cultures`;
  const url = `${config.localizationUIServerUrl}${endpoint}`;

  const results = await fetch(url, {
    method: 'GET',
    headers: getDefaultHeaders(),
  });

  if (!results.ok) {
    throw new ApiError('get missing cultures failed', results);
  }

  return await results.json();
}
